module.exports = __webpack_public_path__ + "static/img/new-8.e33b3a5d.jpg";